import axios from './axios'

const getStatisticsGraphik = (accessKey, type, data, city) => axios.get(`/statistics/${type}?accessKey=${accessKey}&dateFrom=${data?.dateFrom}&dateTo=${data?.dateTo}${city === 'Without city' ? '&town=null' : `&town=${city}`}`)
const getUsers = (accessKey, type) => axios.get(`/statistics/users/full?accessKey=${accessKey}&limit=${100000}`)
const getStatistics = (accessKey, data, city) => axios.get(`/statistics/summary?accessKey=${accessKey}&dateFrom=${data?.dateFrom}&dateTo=${data?.dateTo}${city === 'Without city' ? '&town=null' : `&town=${city}`}`)
const getStatisticsReviews = accessKey => axios.get(`/statistics/users/meetings/reviews?accessKey=${accessKey}`)
const getStoryReports = accessKey => axios.get(`reports/story?accessKey=${accessKey}`)
const deleteStoryReport = (accessKey, reportUuid, type) => axios.post(`/reports/story/${reportUuid}/${type}`, { accessKey })
const getMeetingsReports = accessKey => axios.get(`/reports/meeting?accessKey=${accessKey}`)
const deleteMeetingReport = (accessKey, reportUuid, type) => axios.post(`/reports/meeting/${reportUuid}/${type}`, { accessKey })
const uploadImgsStorys = (accessKey, arrImgs, contentType) => axios.post('/story/image', {
  accessKey,
  images: arrImgs,
  contentType,
})
const getStoryImageCount = () => axios.get('/story/image/count')
const getStoryImg = (limit, skip) => axios.get(`/story/image?limit=${limit}&skip=${skip}&contentType=1`)
const deleteStoryById = (accessKey, id) => axios.delete(`/story/image/${id}?accessKey=${accessKey}`)
const getEmails = accessKey => axios.get(`/email/template?accessKey=${accessKey}`)
const getTemplateById = (accessKey, id) => axios.get(`/email/template/${id}?accessKey=${accessKey}`)
const createTemplate = (accessKey, data) => axios.post('/email/template', {
  accessKey,
  ...data,
})
const updateTemplate = (accessKey, id, json, html) => axios.put(`/email/template/${id}`, {
  accessKey,
  json,
  html,
})
const deleteTemplate = (accessKey, id) => axios.delete(`/email/template/${id}?accessKey=${accessKey}`)
const sendTemplate = data => axios.post('/email/template/send', data)
const getSendCountUsers = data => axios.post('/email/receivers/count', data)
const getTagsContext = accessKey => axios.get(`/email/template/context?accessKey=${accessKey}`)
const getTag = (accessKey, context) => axios.get(`/email/template/merge-tag?accessKey=${accessKey}&context=${context}`)
const getTowns = accessKey => axios.get(`/statistics/towns?accessKey=${accessKey}`)
const uploadFilesMail = (accessKey, arrImgs) => axios.post('/file', {
  accessKey,
  files: arrImgs,
})
const createPodcast = data => axios.post('/story/podcast', data)
const editPodcast = (id, data) => axios.put(`/story/podcast/${id}`, data)
const uploadAudioPodcast = data => axios.post('podcast', data)
const deletePodcast = (accessKey, id) => axios.delete(`/story/podcast/${id}?accessKey=${accessKey}`)
const deletePodcastAudio = (accessKey, id) => axios.delete(`/podcast/${id}?accessKey=${accessKey}`)
const getPodcast = accessKey => axios.get(`/story/podcasts/reaction?accessKey=${accessKey}`)
const getFullStory = (accessKey, skip) => axios.get(`/story?content=1&accessKey=${accessKey}&limit=20&skip=${skip}`)
const getStoryCount = options => axios.get('/story/count')
const updatePodcastAudio = (id, accessKey, duration, listenCountDefault) => axios.put(`/podcast/${id}`, {
  accessKey,
  duration: +duration,
  listenCountDefault,
})
const deleteProfile = accessKey => axios.delete(`user?accessKey=${accessKey}`)
const deleteUser = (accessKey, id) => axios.delete(`/user/${id}?accessKey=${accessKey}`)
const userBlocked = accessKey => axios.get(`/user/blocked?accessKey=${accessKey}`)
const unBlockUser = (accessKey, email) => axios.post(`/user/blocked/unblock/${email}`, {
  accessKey,
})
const deleteStory = (id, accessKey) => axios.delete(`story?accessKey=${accessKey}&uuid=${id}`)

const apiAdmin = {
  getStatisticsGraphik,
  getUsers,
  getStatistics,
  getStatisticsReviews,
  getStoryReports,
  deleteStoryReport,
  getMeetingsReports,
  uploadImgsStorys,
  getStoryImg,
  deleteStoryById,
  getStoryImageCount,
  getEmails,
  createTemplate,
  updateTemplate,
  deleteTemplate,
  getTemplateById,
  sendTemplate,
  getSendCountUsers,
  getTagsContext,
  getTag,
  getTowns,
  uploadFilesMail,
  deleteMeetingReport,
  createPodcast,
  uploadAudioPodcast,
  deletePodcast,
  getPodcast,
  deletePodcastAudio,
  updatePodcastAudio,
  editPodcast,
  deleteProfile,
  deleteUser,
  userBlocked,
  unBlockUser,
  getFullStory,
  deleteStory,
  getStoryCount,
}

export default apiAdmin
